import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import { Form } from '@dex/bubl-dash/src/lib/functions/useForm';
import Line from '@dex/bubl-dash/src/lib/components/Line/Line';
import Button, { ButtonRow } from '@dex/bubl-dash/src/lib/components/Button/Button';

import FieldText from '@dex/bubl-dash/src/lib/components/Fields/FieldText'
import FieldRadio from '@dex/bubl-dash/src/lib/components/Fields/FieldRadio'
import FieldUpload from '@dex/bubl-dash/src/lib/components/Fields/FieldUpload'
import FieldRelationship from '@dex/bubl-dash/src/lib/components/Fields/FieldRelationship';
import { useApp } from '@dex/bubl-dash/src/lib/functions/useApp';


const NewsTagCreateEditForm: React.FC<any> = (props: any) => {

    const { form, process, handleSubmit } = props;

    const app = useApp();

    const manageGlobal = app.userCan(['manageGlobal'], false);

    console.log(manageGlobal);

    // eslint-disable-next-line
    let data = props.data || {};

    return useMemo(() => (

        <Panel
            heading={"News Tag Details"}
        >

            <Form
                form={form}
                onSubmit={handleSubmit}
                loading={process.loading}
            >

                <Row gutter={8} edge={true}>

                    <Col col={{ xs: 24, md: 12 }}>

                        <FieldText
                            form={form}
                            label="Title"
                            name="title"
                            required={true}
                            defaultValue={form.defaults.title}
                        />

                    </Col>

                    {manageGlobal &&
                        <Col col={{ xs: 24, md: 12 }}>

                            <FieldRelationship
                                form={form}
                                label='Host'
                                name='hostId'
                                required={true}
                                preload={true}
                                endpoint={'Hosts'}
                                defaultValue={form.defaults.hostId}
                            />

                        </Col>
                    }

                    <Col col={{ xs: 24, md: 24 }}>

                        <FieldRadio
                            form={form}
                            label="Status"
                            name="status"
                            required={true}
                            defaultValue={form.defaults.status}
                            options={[
                                { value: "publish", label: "Publish" },
                                { value: "archive", label: "Archive" },
                            ]}
                        />

                    </Col>
                    <Col col={{ xs: 24, md: 24 }}>

                        <FieldUpload
                            form={form}
                            folder='admin-media'
                            label="Thumbnail"
                            name="thumbnail"
                            required={false}
                            defaultValue={form.defaults.thumbnail}
                            limit={1}
                        />

                    </Col>

                </Row>

                <Line />

                <ButtonRow>
                    <Button
                        label={"Submit"}
                        loading={process.loading}
                    />
                    <Button
                        label={"Reset"}
                        type={"faded"}
                        onClick={form.reset}
                    />
                </ButtonRow>

            </Form>

        </Panel>


    ), [props]);

}

export default NewsTagCreateEditForm;
